import { Pipe, PipeTransform } from '@angular/core';
import { combineLatest, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { TranslateWithAmountService } from '../../core/services/translate-with-amount.service';
import { ProductConfig } from '../../core/models/supplementary-insurance-configurations';

@Pipe({
  standalone: false,
  name: 'translateProductConfiguration',
})
export class TranslateProductConfigurationPipe implements PipeTransform {
  constructor(private translateWithAmountService: TranslateWithAmountService) {}

  // eslint-disable-next-line rxjs-x/finnish
  public transform(productConfig: ProductConfig[]): Observable<string> {
    return combineLatest(
      productConfig.map(({ key, amount }) => this.translateWithAmountService.stream$(key, amount)),
    ).pipe(map((translations) => translations.join(', ')));
  }
}
